import styled from 'styled-components'

import LargeDownloadBanner from '../../organisms/LargeDownloadBanner'

import { ResponsiveSizeV2 } from '@/components/atomic/_enums'
import color from '@/components/cell/designTokens/color'
import { useLocales } from '@/shared/hooks/useLocales'
import { cn } from '@/shared/utils'

export interface Props {
  children?: React.ReactNode
}

const ResponsiveLayout = ({ children }: Props): JSX.Element => {
  const { isLocale } = useLocales()
  return (
    <div
      className={cn('min-h-screen m-auto flex flex-row justify-center', {
        'bg-gray-200': isLocale.KR,
        'bg-yellow-100': !isLocale.KR,
      })}
    >
      <div className="hidden lg:block lg:w-[360px] lg:min-w-[360px] lg:mr-4">
        <BannerWrapper>
          <LargeDownloadBanner />
        </BannerWrapper>
      </div>
      <StyledMain id="frameMain">{children}</StyledMain>
    </div>
  )
}

const BannerWrapper = styled.div`
  height: 100%;
  padding-top: 150px;
`
const StyledMain = styled.main`
  position: relative;

  // 모양
  width: 100%;
  // 색상
  background-color: ${color.white};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);

  // isDesktop
  @media screen and (min-width: ${ResponsiveSizeV2.MOBILE_MAX_WIDTH}px) {
    max-width: ${ResponsiveSizeV2.MOBILE_WIDTH}px;
  }
`

export default ResponsiveLayout
